import { AsyncRequest } from 'angieslist-app-platform';
import keymirror from 'keymirror';

export default {
  ...AsyncRequest.createActionKeys('GET_AGREEMENT_STATUS'),
  ...keymirror({
    ENABLE_LEGAL_REDIRECT: null,
    DISABLE_LEGAL_REDIRECT: null,
  }),
};



// WEBPACK FOOTER //
// ./src/app/common/agreement/agreementActionKeys.js